import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';  // Importar HttpClient
import { RoutingService } from '../../services/routing.service';

@Component({
  selector: 'app-references',
  templateUrl: './references.component.html',
  styleUrls: ['./references.component.css']
})
export class ReferencesComponent implements OnInit {
  references: { number: number, description: string }[] = []; // Crear una propiedad para almacenar las referencias

  constructor(private http: HttpClient, public routes: RoutingService) { }

  ngOnInit() {
    this.getReferences();  // Llamar a la función que obtiene las referencias
  }

  getReferences() {
    const url = 'https://api.calobesidad.innsider.com.co/api/illness-data/'; // URL del endpoint

    this.http.get<any>(url).subscribe(
      (data) => {
        // Crear una lista de referencias vacía al inicio
        let newReferences: { number: number, description: string }[] = [];

        // Recorrer cada enfermedad del objeto de respuesta
        for (const enfermedad in data) {
          if (data.hasOwnProperty(enfermedad)) {
            const enfermedadData = data[enfermedad];

            // Revisar si existen referencias para masculino o femenino sin usar encadenamiento opcional
            const masculinoReferencias = enfermedadData.Detalles_por_genero.masculino && enfermedadData.Detalles_por_genero.masculino.referencias ? enfermedadData.Detalles_por_genero.masculino.referencias : [];
            const femeninoReferencias = enfermedadData.Detalles_por_genero.femenino && enfermedadData.Detalles_por_genero.femenino.referencias ? enfermedadData.Detalles_por_genero.femenino.referencias : [];
            const ambosReferencias = enfermedadData.Detalles_por_genero.ambos && enfermedadData.Detalles_por_genero.ambos.referencias ? enfermedadData.Detalles_por_genero.ambos.referencias : [];

            // Concatenar las referencias de masculino y femenino en el arreglo
            newReferences = newReferences.concat(masculinoReferencias, femeninoReferencias, ambosReferencias);
          }
        }

        // Asignar las referencias a la propiedad `references`
        this.references = newReferences;
      },
      (error) => {
        console.error('Error al obtener las referencias:', error);
      }
    );
  }
}
